<template>
	<div>
    <h4>Настройки</h4>
    <label>
      <span>Выберите текст:</span>
      <v-select @input="onSelectText"
                label="text" 
                :options="textsData" 
                v-model="params.text_id" 
                :reduce="option => option.id"
                :clearable="false">
        <template slot="option" slot-scope="option">
          <div class="d-center" v-html="option.html"></div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center"> {{ option.text }} </div>
        </template>
      </v-select> 
    </label>
    <div class="razd"></div>
    <label class="">
      <span>Скорость (слов в минуту)</span>
      <input type="text" class="uk-input" v-model="params.speed">
    </label>
		<!--<div class="razd"></div>
		<label class="check_label">
			<input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
			<span>Анимации</span>
		</label>-->
	</div>
</template>

<script>
  import { texts_settings_mixin } from '../../texts/texts_settings_mixin'
  export default {
    name: "settings",
    mixins: [ texts_settings_mixin ],
    watch: {
      params: {
        handler: function (newValue) {
          this.checkValues(newValue);
          if (!this.ingame) {
            this.$emit('params_changed', this.params);
          }
        },
        deep: true
      },      
    },
    data() {
      return {
        sizes: [
          {
            id: '3',
            text: '3x3'
          },
          {
            id: '4',
            text: '4x4'
          },
          {
            id: '5',
            text: '5x5'
          },
          {
            id: '6',
            text: '6x6'
          },
          {
            id: '7',
            text: '7x7'
          },
          {
            id: '8',
            text: '8x8'
          },
        ],
	      params: ''
      }
    },
    props: {
      is_homework: ''
    },
    computed: {
      role() {
        return this.$store.state.user.role.code;
      },
    },
    methods: {
      checkValues(val) {
        if(!Number.isInteger(+val.speed)) this.params.speed = 100;
        if(+val.speed > 900) this.params.speed = 900;
      }
    },
	  mounted() {
      this.params = this.$store.state.train.spritz_params;
    }
  }
</script>